export default __webpack_public_path__ + "static/media/image2.84b4e039.png";